module.exports = __webpack_public_path__ + "static/simple-scatter-eeaa1219edba1e975a181777903d0c39.png";